<div
	[class]="'rx-awareness-banner-container'"
	[class.mt-4]="!flat"
	[class.rx-awareness-banner-container--flat]="flat"
	class="rx-app-flex-container-row rx-app-flex-container-row--justify-space-between rx-app-flex-container-row--align-center">
	<ng-content></ng-content>
	<button *ngIf="showBannerButton" tlkButton variant="ghost" size="s" (click)="openPopup()" class="rx-awareness-banner-trigger">{{ 'Awareness.BannerTitleOpenQR' | translate }}</button>
	<rx-awareness-qr-code *ngIf="qrName" [qrName]="qrName" class="rx-awareness-mini-popup-qr" width="256" height="256"></rx-awareness-qr-code>
</div>

